/* Currently used to keep everyone organised. This might change into a class in future if required */

enum ROLE {
  SUPERADMIN,
  ADMIN,
  DEBUG,
  TESTER = 100,
  USER = 200,
  NONE = 1000,
}

export interface LoginState {
  msg: string;
  status: boolean;
}
export interface UserData {
  userId: string;
  email: string;
  role: ROLE;
}

export { ROLE };
